import { render, staticRenderFns } from "./reset_password_form.vue?vue&type=template&id=0faf64ae"
import script from "./reset_password_form.vue?vue&type=script&lang=js"
export * from "./reset_password_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports